import FnrFetch3, { callMockResponse } from "Utilities/FnrFetch/FnrFetch3";
import { mockData } from "./mockData";

const API = {
  getAdminSettings: () =>
    mockData.shouldMock
      ? callMockResponse(mockData.getAdminSettings)
      : new FnrFetch3(`/familyregistration/getAdminSettings`),

  updateSetting: (postData) =>
    mockData.shouldMock
      ? callMockResponse(mockData.updateSetting(postData))
      : new FnrFetch3(`/familyregistration/updateSetting`, postData),

  checkStatusInUse: (postData) =>
    mockData.shouldMock
      ? callMockResponse(mockData.checkStatusInUse(postData))
      : new FnrFetch3("/familyregistration/checkStatusInUse", postData),

  getAvailableGroups: () =>
    mockData.shouldMock
      ? console.log("no mock response")
      : new FnrFetch3("/familyregistration/getAvailableGroups"),
};

export default API;
